import React from "react";
import { View, SafeAreaView, Pressable } from "react-native";
import { useRouter } from "expo-router";
import { UserProfile } from "@clerk/clerk-react";
import StyledText from "../components/common/ui/styled-text";
import { ArrowLeft } from "lucide-react-native";

export default function ProfilePage() {
  const router = useRouter();

  const handleBackPress = () => {
    router.back();
  };

  return (
    <SafeAreaView className="flex-1 bg-white">
      <View className="flex-row items-center justify-between p-4 border-b border-gray-200 h-[64px]">
        <Pressable onPress={handleBackPress} className="flex-row items-center">
          <ArrowLeft size={20} />
          <StyledText className="ml-2 text-lg font-semibold">
            Profile
          </StyledText>
        </Pressable>
      </View>

      <View className="flex-1 items-center overflow-y-auto p-4 sm:pl-20 lg:pl-4">
        <UserProfile />
      </View>
    </SafeAreaView>
  );
}
